import { render, staticRenderFns } from "./vc-input.vue?vue&type=template&id=c9627b6a&scoped=true&"
import script from "./vc-input.vue?vue&type=script&lang=js&"
export * from "./vc-input.vue?vue&type=script&lang=js&"
import style0 from "./vc-input.vue?vue&type=style&index=0&id=c9627b6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9627b6a",
  null
  
)

export default component.exports